import { getAPIConfig } from "../../../util/api-config";
import { handleError } from "../../../util/errorHandler";
import store from "../../configureStore";
import {
  GET_SYSTEM_STATUS_MESSAGES,
  setCurrentSystemStatusMessages,
  setSystemStatusMessages,
} from "../../reducers/systemStatusMessageReducer";
import { call, put } from "@redux-saga/core/effects";
import { toast } from "react-toastify";
import confirmSaga from "./modalSagas";
import { SystemStatusMessageApi } from "../../../generated/api";
import i18n from "../../../i18n/i18n";

function setUpClient() {
  return new SystemStatusMessageApi(
    getAPIConfig(store.getState().settings.internalSettings)
  );
}

export function* handleDeleteSystemStatusMessageModal(action: any): any {
  try {
    const isConfirmed = yield call(confirmSaga, "delete");
    if (isConfirmed) {
      yield call(handleDeleteSystemStatusMessage, action);
    }
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleDeleteSystemStatusMessage(action: any): any {
  try {
    const systemStatusMessageClient = setUpClient();
    yield systemStatusMessageClient.deleteSystemStatusMessage(action.messageId);
    toast.success(String(i18n.t("toasts.systemMessageDeleted")));
    yield put({ type: GET_SYSTEM_STATUS_MESSAGES });
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleGetAllSystemStatusMessages(): any {
  try {
    const systemStatusMessageClient = setUpClient();
    const response =
      yield systemStatusMessageClient.getAllSystemStatusMessages();
    yield put(setSystemStatusMessages(response));
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleGetCurrentSystemStatusMessagesForUser(): any {
  try {
    const systemStatusMessageClient = setUpClient();
    const response =
      yield systemStatusMessageClient.getCurrentSystemStatusMessageForUser();
    yield put(setCurrentSystemStatusMessages(response));
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleSaveSystemStatusMessage(action: any): any {
  try {
    const systemStatusMessageClient = setUpClient();

    yield systemStatusMessageClient.saveSystemStatusMessage(
      action.systemStatusMessage
    );
    toast.success(String(i18n.t("toasts.systemMessageSaved")));
    yield put({ type: GET_SYSTEM_STATUS_MESSAGES });
  } catch (error) {
    yield handleError(error);
  }
}
